var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "23px",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "successRate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "successRate",
    fill: "#061B2D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3333333,10.08 C17.3333333,5.29440896 13.5118662,1.41 8.79166667,1.41 C4.07146714,1.41 0.25,5.29440896 0.25,10.08 C0.25,14.865591 4.07146714,18.75 8.79166667,18.75 C13.5118662,18.75 17.3333333,14.865591 17.3333333,10.08 Z M1.75,10.08 C1.75,6.11740061 4.90542884,2.91 8.79166667,2.91 C12.6779045,2.91 15.8333333,6.11740061 15.8333333,10.08 C15.8333333,14.0425994 12.6779045,17.25 8.79166667,17.25 C4.90542884,17.25 1.75,14.0425994 1.75,10.08 Z",
    id: "Oval-4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7916667,10.08 C13.7916667,7.28263406 11.5558577,5.01 8.79166667,5.01 C6.02747563,5.01 3.79166667,7.28263406 3.79166667,10.08 C3.79166667,12.8773659 6.02747563,15.15 8.79166667,15.15 C11.5558577,15.15 13.7916667,12.8773659 13.7916667,10.08 Z M5.29166667,10.08 C5.29166667,8.10562571 6.86143733,6.51 8.79166667,6.51 C10.721896,6.51 12.2916667,8.10562571 12.2916667,10.08 C12.2916667,12.0543743 10.721896,13.65 8.79166667,13.65 C6.86143733,13.65 5.29166667,12.0543743 5.29166667,10.08 Z",
    id: "Oval-4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    cx: 8.79166667,
    cy: 10.08,
    rx: 1.41666667,
    ry: 1.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5043858,2.8991378 C16.699648,2.70387566 16.699648,2.38729317 16.5043858,2.19203102 C16.3091237,1.99676888 15.9925412,1.99676888 15.7972791,2.19203102 L8.93099599,9.05831409 C8.73573385,9.25357623 8.73573385,9.57015872 8.93099599,9.76542087 C9.12625814,9.96068301 9.44284063,9.96068301 9.63810278,9.76542087 L16.5043858,2.8991378 Z",
    id: "Line",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7020273,1.62374675 C14.7020273,1.62374675 15.4132152,1.98374675 15.7645273,1.98374675 C16.1215485,1.98374675 16.8270273,1.62374675 16.8270273,1.62374675 L16.8270273,3.78374675 C16.8270273,3.78374675 16.0332553,4.14374675 15.7645273,4.14374675 C15.324922,4.14374675 14.7020273,3.78374675 14.7020273,3.78374675 L14.7020273,1.62374675 Z",
    id: "Rectangle",
    transform: "translate(15.764527, 2.883747) rotate(-315.000000) translate(-15.764527, -2.883747) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7960525,2.1791378 C15.9913147,1.98387566 15.9913147,1.66729317 15.7960525,1.47203102 C15.6007904,1.27676888 15.2842079,1.27676888 15.0889457,1.47203102 L8.22266266,8.33831409 C8.02740052,8.53357623 8.02740052,8.85015872 8.22266266,9.04542087 C8.41792481,9.24068301 8.7345073,9.24068301 8.92976944,9.04542087 L15.7960525,2.1791378 Z",
    id: "Line",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.993694,0.90374675 C13.993694,0.90374675 14.7048818,1.26374675 15.056194,1.26374675 C15.4132152,1.26374675 16.118694,0.90374675 16.118694,0.90374675 L16.118694,3.06374675 C16.118694,3.06374675 15.324922,3.42374675 15.056194,3.42374675 C14.6165887,3.42374675 13.993694,3.06374675 13.993694,3.06374675 L13.993694,0.90374675 Z",
    id: "Rectangle",
    transform: "translate(15.056194, 2.163747) rotate(-315.000000) translate(-15.056194, -2.163747) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5043858,4.3391378 C16.699648,4.14387566 16.699648,3.82729317 16.5043858,3.63203102 C16.3091237,3.43676888 15.9925412,3.43676888 15.7972791,3.63203102 L8.93099599,10.4983141 C8.73573385,10.6935762 8.73573385,11.0101587 8.93099599,11.2054209 C9.12625814,11.400683 9.44284063,11.400683 9.63810278,11.2054209 L16.5043858,4.3391378 Z",
    id: "Line",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7020273,3.06374675 C14.7020273,3.06374675 15.4132152,3.42374675 15.7645273,3.42374675 C16.1215485,3.42374675 16.8270273,3.06374675 16.8270273,3.06374675 L16.8270273,5.22374675 C16.8270273,5.22374675 16.0332553,5.58374675 15.7645273,5.58374675 C15.324922,5.58374675 14.7020273,5.22374675 14.7020273,5.22374675 L14.7020273,3.06374675 Z",
    id: "Rectangle",
    transform: "translate(15.764527, 4.323747) rotate(-315.000000) translate(-15.764527, -4.323747) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRate);
export default __webpack_public_path__ + "static/media/successRate.793ca2b421285e758b89980d3e155064.svg";
export { ForwardRef as ReactComponent };